import { shallowEqual, useSelector } from 'react-redux'

import { selectDirection } from 'features/userSettings/selectors'

export const useDirection = () => {
  const direction = useSelector(selectDirection, shallowEqual)

  return direction
}
